import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";

const digitsOnly = (v) => (v || "").toString().replace(/\D/g, "");
const localTen = (v) => {
  let d = digitsOnly(v);
  if (d.startsWith("90")) d = d.slice(2);
  else if (d.startsWith("0")) d = d.slice(1);
  return d.slice(0, 10);
};
const format = (d) => {
  const p = [d.slice(0, 3), d.slice(3, 6), d.slice(6, 8), d.slice(8, 10)].filter(Boolean);
  return p.join(" ");
};

/**
 * Turkish mobile phone input with a fixed +90 prefix rendered outside the input.
 * Internal state stores exactly 10 local digits; parent receives normalized `+90XXXXXXXXXX`.
 * Backspace / paste / partial input all work naturally.
 */
export default function PhoneInput({ value = "", onChange, placeholder = "5XX XXX XX XX", testid, disabled }) {
  const [local, setLocal] = useState(() => localTen(value));

  // Keep internal state in sync when parent-provided value changes externally.
  useEffect(() => {
    const inbound = localTen(value);
    if (inbound !== local) setLocal(inbound);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const handle = (e) => {
    const d = localTen(e.target.value);
    setLocal(d);
    onChange(d.length ? `+90${d}` : "");
  };

  return (
    <div className="flex items-stretch mt-1">
      <span className="inline-flex items-center px-3 rounded-l-xl border border-r-0 border-input bg-muted text-sm font-semibold text-muted-foreground select-none">+90</span>
      <Input
        data-testid={testid}
        inputMode="tel"
        type="tel"
        autoComplete="tel-national"
        placeholder={placeholder}
        value={format(local)}
        onChange={handle}
        disabled={disabled}
        maxLength={13}
        className="rounded-l-none h-10"
      />
    </div>
  );
}
